import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface DocumentLoadErrorProps {
  className?: string;
}

export const DocumentLoadError = ({ className }: DocumentLoadErrorProps) => {
  const { t } = useTranslation();

  return (
    <p className={cn('p-6 text-sm', className)}>
      {t('documentViewer.loadError')}
    </p>
  );
};
